
/**
 * Helper function to check if a service is a carwash service (for frontend)
 * @param {string} serviceId - The service ID
 * @param {Array} allServiceTypes - Array of all service types
 * @returns {boolean} - True if the service is a carwash service
 */
export function isCarwashService(serviceId, allServiceTypes) {
    const service = allServiceTypes?.find(s => s.id === serviceId);
    return service && service.name && service.name.toLowerCase().includes('car wash');
}